import TemplateFrame from "../../../components/atoms/templateFrame";
import Teaser, { TeaserProps } from "../../../components/molekules/teaser";

function HomeTeaser() {
  const teaser: TeaserProps[] = [
    {
      imageSrc: "./static/IMG_1105.JPG",
      headline: "Überschrift 1",
      text: "Das ist der Text für den Teaser",
      reverse: false,
    },
    {
      imageSrc: "./static/IMG_7302.JPG",
      headline: "Überschrift 2",
      text: "Das ist der Text für den Teaser",
      reverse: true,
    },
    {
      imageSrc: "./static/IMG_9049.JPG",
      headline: "Überschrift 3",
      text: "Das ist der Text für den Teaser",
      reverse: false,
    },
    {
      imageSrc: "./static/IMG_9620.JPG",
      headline: "Überschrift 4",
      text: "Das ist der Text für den Teaser",
      reverse: true,
    },
  ];
  return (
    <TemplateFrame>
      <div className="pt-8 md:px-8">
        {teaser.map(({ imageSrc, headline, text, reverse }) => (
          <Teaser
            imageSrc={imageSrc}
            headline={headline}
            text={text}
            reverse={reverse}
          />
        ))}
      </div>
    </TemplateFrame>
  );
}

export default HomeTeaser;
